import { render } from "./StatusItem.vue?vue&type=template&id=16f2ffff&scoped=true"
import script from "./StatusItem.vue?vue&type=script&lang=js"
export * from "./StatusItem.vue?vue&type=script&lang=js"

import "./StatusItem.vue?vue&type=style&index=0&id=16f2ffff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f2ffff"]])

export default __exports__